export const EditBetTrackingLocation = 'Edit Bet';
